import { render, staticRenderFns } from "./SmsRecipientList.vue?vue&type=template&id=3c9746b6&"
import script from "./SmsRecipientList.vue?vue&type=script&lang=ts&"
export * from "./SmsRecipientList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports